<template>
    <div>
        <!-- 遮罩层 -->
        <div v-if="isOpen" class="user-overlay" @click="closeUserInfo"></div>

        <!-- 用户信息面板 -->
        <div class="user-panel" :class="{ 'user-open': isOpen }">
            <!-- 顶部图标 -->
            <div class="panel-top-icons">
                <button class="icon-btn" @click.stop="toggleSearch">
                    <img src="../assets/icon/search_black.png" alt="search" class="icon-img" />
                </button>
                <button class="icon-btn active">
                    <img src="../assets/icon/user_black.png" alt="search" class="icon-img" />
                </button>
                <button class="icon-btn" @click.stop="toggleEnquiry">
                    <img src="../assets/icon/product_black.png" alt="search" class="icon-img" />
                </button>
            </div>

            <!-- 用户内容 -->
            <div class="user-content" v-if="!isEditing" style="padding-right: 42rem;">
                <div v-if="!isLogin" class="welcome-section" style="padding-top:35%">
                    <h2 class="font-apercu-medium">Login to unlock exclusive access</h2>
                </div>
				<div v-else>
					<div v-if="isLogin" class="welcome-section">
						<h2 class="font-apercu-medium">Welcome Holm, {{ userInfo.UserName }}</h2>
						<p class="customer-type font-apercu-medium">{{ userType === 'private' ? 'Private Customer' : 'Trader Account' }}</p>
					</div>

					<!-- Private Customer View -->
				   <div v-if="userType === 'private'" class="info-grid">
						<div class="info-row">
							<span class="info-label font-apercu-medium">{{ userInfo.FirstName + ' '+userInfo.LastName }}</span>
							<span class="info-value font-apercu-medium">{{ userInfo.Email }}</span>
						</div>
						<div class="info-row edit-row" style="align-items: flex-end !important;">
							<a href="#" class="edit-link font-apercu-medium" @click="handleEditDetails">Edit Details</a>
						</div>
					</div>

					<!-- Trader View -->
					<div v-else class="info-grid">
						<div class="info-row">
							<span class="info-label font-apercu-medium">Boss</span>
							<div class="trader-details">
								<span class="info-value font-apercu-medium">{{ userInfo.UserName }}</span>
								<a href="#" class="edit-link font-apercu-medium" @click="handleEditDetails">Edit Details</a>
							</div>
						</div>
						<div class="explore-section">
							<a href="#" class="explore-link font-apercu-medium">Explore Exclusive Content</a>
						</div>
					</div>
				</div>

                <div v-if="isLogin" class="bottom-actions font-apercu-medium">
                    <a href="#" class="action-link" @click.prevent="toggleUserType">
                        {{ userType === 'private' ? "Switch to Trade Account *" : "I'm a private customer *" }}
                    </a>
                    <a href="#" class="action-link" style="padding-left: 17rem;" @click.prevent="logout">Log out</a>
                </div>
				
				<div v-if="!isLogin" class="bottom-actions font-apercu-medium">
				    <a href="#" class="action-link" @click.prevent="toggleLogin">
				       Login
				    </a>
				    <a href="#" class="action-link" style="padding-left: 17rem;" @click.prevent="toggleRegister">Register</a>
				</div>
            </div>
			
            <div class="user-content" v-else>
                <div class="welcome-section">
                    <h2>Edit Details</h2>
                    <p class="customer-type">{{ userType === 'private' ? 'Private customer' : 'Trader' }}</p>
                </div>
                <div class="edit-grid">
                    <div class="edit-row" v-for="field in editFieldList" :key="field.key">
                        <label class="edit-label">{{ field.label }}</label>
                        <input v-model="editForm[field.key]" class="edit-input"
                            :placeholder="field.placeholder || `Enter your ${field.label}`"
                            :type="field.type || 'text'" />
                    </div>
                    <div style="width: 100%;display: flex;justify-content: flex-end;align-items: flex-end;">
                        <button type="submit" class="submit-btn" @click.prevent="saveEdit">[Submit]</button>
                    </div>

                </div>
                <div class="bottom-actions">
                    <a href="#" class="action-link" @click.prevent="cancelEdit">Back</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getUser, clearToken, clearUser, setUser } from '@/config/auth'
import { getUserInfo, updateUserInfo } from '@/api/user'
import { showMessage } from '@/config/message'

export default {
    name: 'UserInfo',
    props: {
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
			isLogin:false,
            userType: 'private',
            userId: null,
            isEditing: false,
            editForm: {
                FirstName: '',
                LastName: '',
                Email: '',
                Phone: '',
                CompanyName: '',
                Position: ''
            },
            userInfo: {
                UserID: null,
                UserName: "denholm",
                Email: "denholm@email.com",
                FirstName: "",
                LastName: "",
                UserType: "private",
                CompanyName: "",
                Position: "",
                Phone: "",
                IsSubscribed: true,
            }
        }
    },
    computed: {
        editFieldList() {
            if (this.userType === 'private') {
                return [
                    { key: 'FirstName', label: 'First Name' },
                    { key: 'LastName', label: 'Last Name' },
                    { key: 'Email', label: 'Email', type: 'email' },
                    { key: 'Phone', label: 'Phone' }
                ]
            }
            return [
                { key: 'CompanyName', label: 'Company Name' },
                { key: 'Position', label: 'Position' },
                { key: 'FirstName', label: 'First Name' },
                { key: 'LastName', label: 'Last Name' },
                { key: 'Email', label: 'Email', type: 'email' },
                { key: 'Phone', label: 'Phone' }
            ]
        }
    },
    watch: {
        isOpen: {
            immediate: true,
            handler(value) {
                if (value) {
                    this.loadUserInfo()
                }
            }
        }
    },
    methods: {
        closeUserInfo() {
            this.$emit('close')
        },
        toggleSearch() {
            this.$emit('toggle-search')
        },
        toggleUserType() {
            // 如果当前是私人，点击后想成为 trader -> 关闭面板并打开 trader 登录
            if (this.userType === 'private') {
                this.closeUserInfo()
                this.$emit('open-trader-login')  // 通知父组件打开 trader 登录
            } else {
                // 已经是 trader，点击后切换为私人（仅界面切换，不触发登录）
                this.userType = 'private'
            }
        },
		 
		toggleLogin(){
			this.closeUserInfo()
			this.$emit('open-private-login')  // 通知父组件打开 trader 登录
		},
		toggleRegister(){
			this.closeUserInfo()
			this.$emit('open-register')
		},
        toggleEnquiry() {
            this.$emit('toggle-enquiry')
        },
        handleEditDetails(event) {
            if (event && event.preventDefault) event.preventDefault()
            this.isEditing = true
            this.editForm.FirstName = this.userInfo.FirstName || ''
            this.editForm.LastName = this.userInfo.LastName || ''
            this.editForm.Email = this.userInfo.Email || ''
            this.editForm.Phone = this.userInfo.Phone || ''
            this.editForm.CompanyName = this.userInfo.CompanyName || ''
            this.editForm.Position = this.userInfo.Position || ''
        },
        cancelEdit() {
            this.isEditing = false
        },
        async saveEdit() {
			
            const userId = this.userId || this.userInfo.UserID
			console.log(userId)
            if (!userId) {
                showMessage('UserID missing', 'error')
                return
            }
            const payload = {
                UserID: Number(userId),
                // UserType: this.userType === 'private' ? 'Private' : 'Trader',
                FirstName: this.editForm.FirstName || '',
                LastName: this.editForm.LastName || '',
                Email: this.editForm.Email || '',
                Phone: this.editForm.Phone || '',
                // CompanyName: this.editForm.CompanyName || '',
                // Position: this.editForm.Position || ''
            }
			console.log(payload)
            try {
                const res = await updateUserInfo(payload)
                this.userInfo = payload
				this.userInfo.UserName = payload.FirstName 
                showMessage('Saved', 'success')
                this.isEditing = false
            } catch (error) {
                console.error('Failed to update user info:', error)
            }
        },
        logout() {
            clearToken()
            clearUser()
            this.isEditing = false
            this.userInfo = {
                UserID: null,
                UserName: '',
                Email: '',
                FirstName: '',
                LastName: '',
                UserType: 'private',
                CompanyName: '',
                Position: '',
                Phone: '',
                IsSubscribed: false,
            }
            this.closeUserInfo()
        },
        async loadUserInfo() {
			 
            const user = getUser()
            console.log('user:', user)
            if (!user) {
				this.isLogin = false
                // showMessage('You are not logged in. Please login first.', 'warning')
                // setTimeout(() => {
                //     this.closeUserInfo()
                // }, 2000)
                return
            }
            const userId = user.UserID || user.UserId || user.userId || user.id
            if (!userId) {
                showMessage('User ID not found.', 'error')
                return
            }
            this.userId = userId
            this.userType = (user.UserType || '').toLowerCase() === 'trader' ? 'trader' : 'private'
			this.isLogin = true
            try {
                const res = await getUserInfo(Number(userId))
                setUser(res)
                this.userInfo = {
                    UserID: res.UserID,
                    UserName: `${res.FirstName}`.trim() || res.Email,
                    Email: res.Email,
                    FirstName: res.FirstName,
                    LastName: res.LastName,
                    UserType: res.UserType,
                    CompanyName: res.CompanyName,
                    Position: res.Position,
                    Phone: res.Phone,
                    IsSubscribed: res.IsSubscribed
                }
            } catch (error) {
                console.error('Failed to load user info:', error)
                this.userInfo = {
                    UserID: userId,
                    UserName: `${user.FirstName || ''} ${user.LastName || ''}`.trim() || user.Email,
                    Email: user.Email,
                    FirstName: user.FirstName || '',
                    LastName: user.LastName || '',
                    UserType: user.UserType,
                    CompanyName: user.CompanyName || '',
                    Position: user.Position || '',
                    Phone: user.Phone || '',
                    IsSubscribed: user.IsSubscribed
                }
            }
        }
    }
}
</script>

<style scoped>
/* 样式保持不变 */
.submit-btn {
    background: none;
    border: none;
    font-size: 16rem;
    font-weight: 500;
    cursor: pointer;
    padding: 0;
}

.icon-img {
    width: 22rem;
    height: 22rem;
}

.user-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    z-index: 998;
    animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.user-panel {
    position: fixed;
    top: 0;
    right: 0;
    width: 30%;
    max-width: 486rem;
    height: 100vh;
    background: #ffffff;
    z-index: 10001;
    transform: translateX(100%);
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
    padding: 90rem;
    border-left: 1rem solid #000;
	padding-top: 42rem;
	padding-right: 42rem;
}

.user-panel.user-open {
    transform: translateX(0);
}

.panel-top-icons {
    display: flex;
    justify-content: flex-end;
    gap: 23rem;
    margin-bottom: 120rem;
}

.icon-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 8rem;
    color: #000;
}

.user-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    gap: 40rem;
}

.welcome-section h2 {
    font-size: 28rem;
    font-weight: 500;
    margin-bottom: 19rem;
    padding-top: 20%;
    color: #000;
}

.customer-type {
    font-size: 20rem;
    font-weight: 500;
    color: #00000080;
    margin: 0;
}

.info-grid {
    width: 100%;
    max-width: 400rem;
    display: flex;
    flex-direction: column;
    gap: 15rem;
    margin-top: 97rem;
}

.edit-grid {
    width: 100%;
    max-width: 400rem;
    display: flex;
    flex-direction: column;
    gap: 18rem;
    margin-top: 20rem;
}

.edit-row {
    display: flex;
    flex-direction: column;
    gap: 8rem;
    text-align: left;
}

.edit-label {
    font-size: 14rem;
    color: rgba(0, 0, 0, 0.5);
    font-weight: 500;
}

.edit-input {
    border: none;
    border-bottom: 1rem solid rgba(0, 0, 0, 0.2);
    padding: 6rem 2rem;
    font-size: 16rem;
    outline: none;
    color: #000;
}

.info-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    font-size: 16rem;
    color: #666;
}

.info-label {
    font-weight: 500;
    color: rgba(0, 0, 0, 0.5);
}

.edit-row {
    justify-content: flex-end;
}

.edit-link {
    color: #000;
    text-decoration: none;
    font-weight: 500;
    font-size: 16rem;
    margin-top: 10rem;
}

.bottom-actions {
    margin-top: auto;
    width: 100%;
    max-width: 400rem;
    display: flex;
    justify-content: center;
}

.action-link {
    color: #000;
    text-decoration: none;
    font-size: 16rem;
    font-weight: 500;
    cursor: pointer;
}

.trader-details {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 5rem;
}

.explore-section {
    margin-top: 88rem;
    text-align: center;
}

.explore-link {
    color: #000;
    font-size: 16rem;
    text-decoration: none;
    font-weight: 500;
}

@media (max-width: 1024px) {
    .user-panel {
        width: 40%;
    }
}

@media (max-width: 768px) {
    .user-panel {
        width: 100%;
    }
}
</style>